export enum DriverCookieName {
  QUICK_SEARCH_MORE_FILTERS = 'driveQuickSearchMoreFilters',
  USER_ACCOUNT_SALE_REQUESTS_MENU_ITEM = 'driveUserAccountSaleRequestsMenuItem',
  CLASSIFIED_EDIT_ESHOP_TAB = 'driveClassifiedEditEshopTab'
}
